import { cipherID } from 'utils/idCipher';

export const getPreviewUrl = (id, isTemplate = false) => {
  const encryptedID = cipherID(id);
  if (isTemplate) {
    return`${window.location.origin}/app/v2/note-template-viewer/${encryptedID}`;
  }
  return`${window.location.origin}/app/v2/note-viewer/${encryptedID}`;

};
